module.exports = __webpack_public_path__ + "img/gin.0feaddbe.svg";